import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Feedback } from '../../api/feedback/interface';
import { actions as feedbackSliceActions } from '../../data/feedback/logic';
import { StoreState } from '../../data/store';

export interface UseFeedbackHookState {
  actions: StoreState['feedback']['actions'];
}

export interface UseFeedbackHookHandler {
  addFeedback(feedbackData: Feedback): void;
}

const useFeedbackHook = (): [UseFeedbackHookState, UseFeedbackHookHandler] => {
  const dispatch = useDispatch();
  const { actions } = useSelector((s: StoreState) => s['feedback']);
  const handler = React.useMemo(
    () => ({
      addFeedback: (feedbackData: Feedback) => {
        dispatch(feedbackSliceActions.addFeedback(feedbackData));
      },
    }),
    []
  );
  return [{ actions }, handler];
};

export default useFeedbackHook;
